const convertSnakeCase = (str: string) => {
  return str
    .split('_')
    .filter((x) => x.length > 0)
    .join(' ')
    .toLowerCase();
};

export default convertSnakeCase;
